import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import { AppProvider, useApp } from './context/AppContext';
import { auth as authApi } from './api';
import PWAPrompt from './components/PWAPrompt';

function RegistraOperatoreModal({ onClose, onSuccess }) {
  const [agenzie, setAgenzie] = useState([]);
  const [form, setForm] = useState({ nome:'', cognome:'', email:'', telefono:'', password:'', agenzia_id:'', anno_nascita:'', codice_fiscale:'', indirizzo_residenza:'', anni_esperienza:'', altezza_cm:'', peso_kg:'', descrizione_skill:'' });
  const [accettaTermini, setAccettaTermini] = useState(false);
  const [accettaPrivacy, setAccettaPrivacy] = useState(false);
  const GIORNI = [
    { id:'lun', label:'Lun' }, { id:'mar', label:'Mar' }, { id:'mer', label:'Mer' },
    { id:'gio', label:'Gio' }, { id:'ven', label:'Ven' }, { id:'sab', label:'Sab' }, { id:'dom', label:'Dom' },
  ];
  const [dispGiorni, setDispGiorni] = useState([]);
  const [dispOraInizio, setDispOraInizio] = useState('08:00');
  const [dispOraFine, setDispOraFine] = useState('20:00');
  const [dispNote, setDispNote] = useState('');
  const toggleGiorno = (id) => setDispGiorni(g => g.includes(id) ? g.filter(x=>x!==id) : [...g, id]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const inp = { background:'#111620', border:'1px solid rgba(255,255,255,.1)', borderRadius:8, padding:'10px 12px', fontSize:13, color:'#e8eaf0', width:'100%' };

  useEffect(() => {
    authApi.agenzie().then(setAgenzie).catch(() => {});
  }, []);

  const handle = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await authApi.registraOperatore({
        ...form,
        agenzia_id: Number(form.agenzia_id),
        anni_esperienza: form.anni_esperienza ? Number(form.anni_esperienza) : null,
        altezza_cm: form.altezza_cm ? Number(form.altezza_cm) : null,
        peso_kg: form.peso_kg ? Number(form.peso_kg) : null,
      });
      onSuccess();
    } catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const f = (k) => ({ value: form[k], onChange: e => setForm(p=>({...p,[k]:e.target.value})) });

  return (
    <div style={{ position:'fixed', inset:0, zIndex:9999, background:'rgba(0,0,0,.85)', display:'flex', alignItems:'center', justifyContent:'center', padding:16 }}>
      <div style={{ background:'#0c1018', border:'1px solid rgba(255,165,0,.2)', borderRadius:18, padding:'28px 24px', width:'100%', maxWidth:440, maxHeight:'90vh', overflowY:'auto' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
          <div>
            <div style={{ fontSize:17, fontWeight:800, color:'#f59e0b' }}>Registrati come Operatore</div>
            <div style={{ fontSize:11, color:'#4a5568', marginTop:3 }}>La tua richiesta sarà approvata dall'agenzia</div>
          </div>
          <button onClick={onClose} style={{ background:'rgba(255,255,255,.08)', border:'none', borderRadius:50, width:30, height:30, color:'#8892a4', fontSize:16, cursor:'pointer' }}>✕</button>
        </div>
        <form onSubmit={handle} style={{ display:'flex', flexDirection:'column', gap:10 }}>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <input placeholder="Nome *" {...f('nome')} style={inp} required />
            <input placeholder="Cognome *" {...f('cognome')} style={inp} required />
          </div>
          <input type="email" placeholder="Email *" {...f('email')} style={inp} required />
          <input type="tel" placeholder="Telefono *" {...f('telefono')} style={inp} required />
          <input type="password" placeholder="Password * (min. 6 caratteri)" {...f('password')} style={inp} required minLength={6} />
          <select {...f('agenzia_id')} style={{...inp, colorScheme:'dark'}} required>
            <option value="">Scegli agenzia *</option>
            {agenzie.map(a => (
              <option key={a.id} value={a.id}>{a.nome}{a.zona ? ` — ${a.zona}` : ''}</option>
            ))}
          </select>
          <div style={{ fontSize:11, color:'#8892a4', marginTop:2 }}>Dati anagrafici <span style={{ color:'#4a5568' }}>(facoltativi — l'agenzia potrà completarli)</span></div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
            <div>
              <div style={{ fontSize:10, color:'#4a5568', marginBottom:4 }}>Anno di nascita</div>
              <input type="number" placeholder="es. 1990" {...f('anno_nascita')} style={inp} min={1950} max={2005} />
            </div>
            <div>
              <div style={{ fontSize:10, color:'#4a5568', marginBottom:4 }}>Codice fiscale</div>
              <input placeholder="RSSMRA85M01H501Z" {...f('codice_fiscale')} style={{...inp, textTransform:'uppercase'}} maxLength={16} onChange={e => setForm(p=>({...p, codice_fiscale: e.target.value.toUpperCase()}))} />
            </div>
          </div>
          <input placeholder="Indirizzo di residenza" {...f('indirizzo_residenza')} style={inp} />
          <div style={{ fontSize:11, color:'#8892a4', marginTop:2 }}>Dati fisici <span style={{ color:'#4a5568' }}>(facoltativi)</span></div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:10 }}>
            <input type="number" placeholder="Esperienza (anni)" {...f('anni_esperienza')} style={inp} min={0} max={50} />
            <input type="number" placeholder="Altezza (cm)" {...f('altezza_cm')} style={inp} min={150} max={220} />
            <input type="number" placeholder="Peso (kg)" {...f('peso_kg')} style={inp} min={50} max={150} />
          </div>
          <div>
            <div style={{ fontSize:11, color:'#8892a4', marginBottom:5 }}>Descrivi le tue skill operative <span style={{ color:'#4a5568' }}>(facoltativo)</span></div>
            <textarea placeholder="Es: Esperto arti marziali, addetto ASC, security eventi, primo soccorso..." {...f('descrizione_skill')} style={{...inp, resize:'vertical', minHeight:80}} />
          </div>
          {/* Termini e Privacy */}
          <div style={{ borderTop:'1px solid rgba(255,255,255,.07)', paddingTop:12, display:'flex', flexDirection:'column', gap:10 }}>
            <label style={{ display:'flex', alignItems:'flex-start', gap:10, cursor:'pointer' }}>
              <input type="checkbox" checked={accettaTermini} onChange={e => setAccettaTermini(e.target.checked)} style={{ marginTop:2, accentColor:'#f59e0b', width:15, height:15, flexShrink:0 }} />
              <span style={{ fontSize:12, color:'#8892a4', lineHeight:1.5 }}>
                Ho letto e accetto la <a href="/dichiarazione-operatore-v1.0.pdf" target="_blank" rel="noopener noreferrer" style={{ color:'#f59e0b', fontWeight:700, textDecoration:'underline' }}>Dichiarazione di Accettazione Operatore</a> — i termini di collaborazione, responsabilità, Codice di Condotta e manleva previsti da AKKKANTO.IT
              </span>
            </label>
            <label style={{ display:'flex', alignItems:'flex-start', gap:10, cursor:'pointer' }}>
              <input type="checkbox" checked={accettaPrivacy} onChange={e => setAccettaPrivacy(e.target.checked)} style={{ marginTop:2, accentColor:'#f59e0b', width:15, height:15, flexShrink:0 }} />
              <span style={{ fontSize:12, color:'#8892a4', lineHeight:1.5 }}>
                Ho letto e accetto la <span style={{ color:'#f59e0b', fontWeight:700 }}>Privacy Policy</span> e autorizzo il trattamento dei dati personali ai sensi del GDPR (Reg. UE 2016/679)
              </span>
            </label>
          </div>
          {error && <div style={{ color:'#ff4d6d', fontSize:12, background:'rgba(255,77,109,.08)', borderRadius:8, padding:'8px 12px' }}>{error}</div>}
          <button type="submit" disabled={loading || !accettaTermini || !accettaPrivacy} style={{ background: (loading || !accettaTermini || !accettaPrivacy) ? '#1a2030' : 'linear-gradient(135deg,#f59e0b,#d97706)', border:'none', borderRadius:10, padding:'13px', color: (!accettaTermini || !accettaPrivacy) ? '#4a5568' : '#000', fontWeight:800, fontSize:14, cursor: (!accettaTermini || !accettaPrivacy) ? 'not-allowed' : 'pointer', marginTop:4, transition:'all .2s' }}>
            {loading ? 'Invio...' : 'Invia richiesta'}
          </button>
          {(!accettaTermini || !accettaPrivacy) && <div style={{ fontSize:11, color:'#4a5568', textAlign:'center', marginTop:-6 }}>Accetta i termini per procedere</div>}
        </form>
      </div>
    </div>
  );
}

// Rileva il portale dall'URL — calcolato una sola volta al caricamento
const PORTALE = (() => {
  const p = window.location.pathname;
  if (p.startsWith('/operatori'))        return 'operatore';
  if (p.startsWith('/agenzia'))          return 'admin';
  if (p.startsWith('/admin'))            return 'admin';
  if (p.startsWith('/alfa'))             return 'superadmin';
  if (p.startsWith('/business-portal'))  return 'business_portal';
  if (p.startsWith('/business'))         return 'business_landing';
  if (p.startsWith('/hotel'))            return 'hotel';
  if (p.startsWith('/negozi'))           return 'negozio';
  if (p.startsWith('/referral/dashboard')) return 'referral_dashboard';
  if (p.startsWith('/referral'))         return 'referral_register';
  return 'cliente';
})();

// Swap manifest per portale operatore
if (PORTALE === 'operatore') {
  const link = document.querySelector('link[rel="manifest"]');
  if (link) link.href = '/manifest-operatore.json';
}

const BusinessPortalPage   = lazy(() => import('./pages/BusinessPortalPage'));
const ReferralRegisterPage = lazy(() => import('./pages/ReferralRegisterPage'));
const ReferralView         = lazy(() => import('./pages/ReferralView'));
const LandingPage          = lazy(() => import('./pages/LandingPage'));
const BusinessLandingPage  = lazy(() => import('./pages/BusinessLandingPage'));
const RegisterPage       = lazy(() => import('./pages/RegisterPage'));
const ClientInfoPage     = lazy(() => import('./pages/ClientInfoPage'));
const AgencyRegisterPage = lazy(() => import('./pages/AgencyRegisterPage'));
const DemoPage           = lazy(() => import('./pages/DemoPage'));
const RichiestaSpontanea   = lazy(() => import('./pages/RichiestaSpontanea'));
const PrenotazioneInfoPage = lazy(() => import('./pages/PrenotazioneInfoPage'));
const PianiPage            = lazy(() => import('./pages/PianiPage'));
const SplashScreen         = lazy(() => import('./pages/SplashScreen'));
const SituazioniPage       = lazy(() => import('./pages/SituazioniPage'));
const TerminiPage          = lazy(() => import('./pages/TerminiPage'));

const STYLE = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  html{height:100%;height:-webkit-fill-available;}
  body{font-family:'DM Sans',sans-serif;background:#06080f;color:#e8eaf0;font-size:13px;height:100%;overflow-x:hidden;-webkit-text-size-adjust:100%;}
  #root{height:100%;display:flex;flex-direction:column;}
  ::-webkit-scrollbar{width:4px}::-webkit-scrollbar-thumb{background:rgba(255,255,255,.12);border-radius:2px}
  @keyframes fadeIn{from{opacity:0;transform:translateY(4px)}to{opacity:1;transform:translateY(0)}}
  @keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}
  .fade-in{animation:fadeIn .2s ease}
  input,button,select,textarea{font-family:'DM Sans',sans-serif}
  button{touch-action:manipulation;}
  @media(max-width:480px){.ap-header-cognome{display:none!important;}.ap-header-user{display:none!important;}}
`;

const ROLES = [
  { key:'cliente',    label:'Cliente'       },
  { key:'operatore',  label:'Operatore'     },
  { key:'admin',      label:'Admin Agenzia' },
  { key:'superadmin', label:'Super Admin'   },
];

function Clock() {
  const [t, setT] = useState(new Date());
  useEffect(() => { const i = setInterval(() => setT(new Date()), 1000); return () => clearInterval(i); }, []);
  return <span style={{ fontFamily:'DM Mono', fontSize:11, color:'#fbbf24' }}>{t.toLocaleTimeString('it-IT')}</span>;
}

function Notifica() {
  const { notification } = useApp();
  const c = {
    success:{ bg:'rgba(0,214,143,.12)', border:'rgba(0,214,143,.3)', color:'#00d68f' },
    error:  { bg:'rgba(255,77,109,.12)', border:'rgba(255,77,109,.3)', color:'#ff4d6d' },
    warn:   { bg:'rgba(251,191,36,.12)', border:'rgba(251,191,36,.3)', color:'#fbbf24' },
  }[notification?.tipo] || {};
  return (
    <div style={{ position:'fixed', top:'calc(env(safe-area-inset-top, 0px) + 16px)', right:16, zIndex:999, background:c.bg, border:`1px solid ${c.border}`, color:c.color, borderRadius:10, padding:'10px 16px', fontSize:12, boxShadow:'0 4px 24px rgba(0,0,0,.5)', transition:'all .3s', opacity:notification?1:0, transform:notification?'translateY(0)':'translateY(-10px)', pointerEvents:'none' }}>
      {notification?.msg}
    </div>
  );
}

function LoginForm({ onRegister, onBack }) {
  const { login, showNotif } = useApp();
  const [form, setForm]   = useState({ email:'', password:'' });
  const [loading, setLoading] = useState(false);

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      showNotif('Accesso effettuato');
    } catch(err) {
      showNotif(err.message, 'error');
    } finally { setLoading(false); }
  };

  const inp = { background:'#111620', border:'1px solid rgba(255,255,255,.1)', borderRadius:8, padding:'9px 12px', fontSize:13, color:'#e8eaf0', width:'100%' };

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', flexDirection:'column', gap:24 }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ fontSize:32, fontWeight:700, letterSpacing:-1 }}>Alfa<span style={{ color:'#00d68f' }}>Protect</span></div>
        <div style={{ fontSize:12, color:'#8892a4', marginTop:4 }}>Alfa Security Srl — P.IVA 02382450225</div>
      </div>
      <div style={{ background:'#0c1018', border:'1px solid rgba(255,255,255,.07)', borderRadius:14, padding:'28px 32px', width:360 }}>
        <div style={{ fontSize:15, fontWeight:500, marginBottom:20 }}>Accedi</div>
        <form onSubmit={handle} style={{ display:'flex', flexDirection:'column', gap:10 }}>
          <input type="text" placeholder="Email o username" value={form.email} onChange={e => setForm(f=>({...f,email:e.target.value}))} style={inp} required autoComplete="username" />
          <input type="password" placeholder="Password (lascia vuoto per account TEST)" value={form.password} onChange={e => setForm(f=>({...f,password:e.target.value}))} style={inp} autoComplete="current-password" />
          <button type="submit" disabled={loading} style={{ background:loading?'#0d4a30':'#00d68f', color:'#000', border:'none', borderRadius:8, padding:'10px', fontWeight:600, fontSize:13, cursor:'pointer', marginTop:4 }}>
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
      </div>
      <div style={{ display:'flex', gap:20, fontSize:13 }}>
        {onRegister && (
          <button onClick={onRegister} style={{ background:'none', border:'none', color:'#8892a4', cursor:'pointer', fontSize:13 }}>
            Non hai un account? <span style={{ color:'#00d68f' }}>Registrati</span>
          </button>
        )}
        {onBack && (
          <>
            <span style={{ color:'#4a5568' }}>·</span>
            <button onClick={onBack} style={{ background:'none', border:'none', color:'#8892a4', cursor:'pointer', fontSize:13 }}>
              ← Home
            </button>
          </>
        )}
      </div>
      <div style={{ fontSize:11, color:'#4a5568', textAlign:'center', maxWidth:320 }}>
        Servizio di accompagnamento personale non armato ai sensi dell'art. 2222 c.c.
      </div>
    </div>
  );
}

// Login OTP per clienti (telefono → OTP)
function OtpLoginForm({ onRegister, onBack, onSuccess }) {
  const { tryAutoLogin } = useApp();
  const [step, setStep] = useState('phone'); // 'phone' | 'otp'
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const otpRef = useRef(null);

  const normalizza = (n) => {
    const t = n.replace(/\s/g, '');
    if (t.startsWith('+')) return t;
    if (t.startsWith('00')) return '+' + t.slice(2);
    return '+39' + t;
  };

  const invia = async () => {
    setError('');
    const num = normalizza(phone.trim());
    if (num.length < 10) { setError('Inserisci un numero valido'); return; }
    setLoading(true);
    try {
      sessionStorage.setItem('ap_prefill_phone', num);
      // 1. Controlla se numero è registrato
      const { registered } = await authApi.checkPhone(num);
      if (registered) {
        // 2. Prova login silenzioso con device token
        const dt = localStorage.getItem('ap_device_token');
        if (dt) {
          try {
            await authApi.deviceLogin();
            const u = await tryAutoLogin();
            if (u && u.ruolo !== 'cliente') {
              authApi.logout();
              setError('Numero non registrato come cliente');
              return;
            }
            return; // → dashboard diretta
          } catch {}
        }
        // 3. Device token non valido → manda OTP per riautenticare
        await authApi.otpSend(num);
        setStep('otp');
        setTimeout(() => otpRef.current?.focus(), 100);
      } else {
        // 4. Numero non registrato → registrazione
        onRegister && onRegister();
      }
    } catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const verifica = async () => {
    setError('');
    if (otp.length < 4) { setError('Inserisci il codice ricevuto'); return; }
    setLoading(true);
    try {
      const num = sessionStorage.getItem('ap_prefill_phone') || normalizza(phone.trim());
      const data = await authApi.otpLogin(num, otp);
      if (data.needs_registration) {
        onRegister && onRegister();
      } else {
        await tryAutoLogin();
        // Salva device token per accessi futuri senza OTP
        authApi.registerDevice().catch(() => {});
        onSuccess && onSuccess(data);
      }
    } catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const inp = { background:'#111620', border:'1px solid rgba(255,255,255,.1)', borderRadius:8, padding:'12px', fontSize:16, color:'#e8eaf0', width:'100%', WebkitAppearance:'none' };

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', flexDirection:'column', gap:20, padding:'0 20px' }}>
      <div style={{ textAlign:'center' }}>
        <div style={{ fontSize:32, fontWeight:700, letterSpacing:-1 }}>Alfa<span style={{ color:'#00d68f' }}>Protect</span></div>
        <div style={{ fontSize:12, color:'#8892a4', marginTop:4 }}>Accesso con numero di telefono</div>
      </div>
      <div style={{ background:'#0c1018', border:'1px solid rgba(255,255,255,.07)', borderRadius:14, padding:'28px 24px', width:'100%', maxWidth:360 }}>
        {step === 'phone' ? (
          <>
            <div style={{ fontSize:15, fontWeight:500, marginBottom:6 }}>Il tuo numero</div>
            <div style={{ fontSize:12, color:'#8892a4', marginBottom:16 }}>Inserisci il tuo numero per accedere o registrarti</div>
            <input type="tel" inputMode="tel" placeholder="+39 333 1234567" value={phone}
              onChange={e => { setPhone(e.target.value); setError(''); }}
              onKeyDown={e => e.key === 'Enter' && invia()} style={inp} autoFocus autoComplete="tel" />
            {error && <div style={{ color:'#ff4d6d', fontSize:12, marginTop:8 }}>{error}</div>}
            <button onClick={invia} disabled={loading || !phone.trim()} style={{ background:loading?'#0d4a30':'#00d68f', color:'#000', border:'none', borderRadius:8, padding:'12px', fontWeight:600, fontSize:14, cursor:'pointer', marginTop:12, width:'100%' }}>
              {loading ? 'Controllo...' : 'Continua →'}
            </button>
          </>
        ) : (
          <>
            <div style={{ fontSize:15, fontWeight:500, marginBottom:6 }}>Codice SMS</div>
            <div style={{ fontSize:12, color:'#8892a4', marginBottom:16 }}>Inviato a <strong style={{ color:'#e8eaf0' }}>{sessionStorage.getItem('ap_prefill_phone')}</strong></div>
            <input ref={otpRef} type="text" inputMode="numeric" pattern="[0-9]*" placeholder="123456" maxLength={6}
              value={otp} onChange={e => { setOtp(e.target.value.replace(/\D/g,'')); setError(''); }}
              onKeyDown={e => e.key === 'Enter' && verifica()}
              autoComplete="one-time-code" style={{ ...inp, letterSpacing:8, textAlign:'center', fontSize:28 }} />
            {error && <div style={{ color:'#ff4d6d', fontSize:12, marginTop:8 }}>{error}</div>}
            <button onClick={verifica} disabled={loading || otp.length < 4} style={{ background:loading?'#0d4a30':'#00d68f', color:'#000', border:'none', borderRadius:8, padding:'12px', fontWeight:600, fontSize:14, cursor:'pointer', marginTop:12, width:'100%' }}>
              {loading ? 'Verifica...' : 'Accedi →'}
            </button>
            <button onClick={() => { setStep('phone'); setOtp(''); setError(''); }} style={{ background:'none', border:'none', color:'#8892a4', cursor:'pointer', fontSize:12, marginTop:10, width:'100%' }}>
              ← Cambia numero
            </button>
          </>
        )}
      </div>
      {onBack && (
        <button onClick={onBack} style={{ background:'none', border:'none', color:'#8892a4', cursor:'pointer', fontSize:13 }}>← Home</button>
      )}
      <div style={{ fontSize:11, color:'#4a5568', textAlign:'center', maxWidth:320 }}>
        Alfa Security Srl · P.IVA 02382450225
      </div>
    </div>
  );
}

const ROLE_LABELS = { cliente:'Cliente', operatore:'Operatore', admin:'Admin Agenzia', superadmin:'Super Admin', hotel:'Hotel', negozio:'Negozio' };
const ROLE_COLORS = { cliente:'#00d68f', operatore:'#4a9eff', admin:'#7ab4e8', superadmin:'#ff4d6d', hotel:'#a855f7', negozio:'#f97316' };

function AppLayout() {
  const { user, logout } = useApp();
  const [View, setView] = useState(null);
  const role = user?.ruolo || 'cliente';

  useEffect(() => {
    const name = role.charAt(0).toUpperCase() + role.slice(1);
    import(`./pages/${name}View`)
      .then(m => setView(() => m.default))
      .catch(() => setView(null));
  }, [role]);

  return (
    <div style={{ display:'flex', flexDirection:'column', height:'100%', overflow:'hidden' }}>
      <div style={{ display:'flex', alignItems:'center', borderBottom:'1px solid rgba(255,255,255,.07)', background:'#0c1018', flexShrink:0, paddingLeft:16, paddingRight:16, paddingTop:'env(safe-area-inset-top, 0px)', paddingBottom:0, minHeight:48, gap:12 }}>
        <div style={{ fontSize:18, paddingRight:12, borderRight:'1px solid rgba(255,255,255,.07)', lineHeight:1 }}>
          <span style={{ fontWeight:900, color:'#ffffff' }}>A</span>
          <span style={{ fontWeight:900, color:'#f59e0b' }}>KKK</span>
          <span style={{ fontWeight:900, color:'#ffffff' }}>ANTO</span>
          <span style={{ fontWeight:900, color:'#f59e0b', fontStyle:'italic' }}>.it</span>
        </div>
        <div style={{ background:`${ROLE_COLORS[role] || '#00d68f'}14`, border:`1px solid ${ROLE_COLORS[role] || '#00d68f'}33`, borderRadius:6, padding:'3px 10px', fontSize:11, fontWeight:600, color: ROLE_COLORS[role] || '#00d68f' }}>
          {ROLE_LABELS[role]}
        </div>
        <div style={{ marginLeft:'auto', display:'flex', alignItems:'center', gap:8, flexShrink:0 }}>
          {user && (
            <div className="ap-header-user" style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', overflow:'hidden' }}>
              <div style={{ fontSize:12, fontWeight:600, color:'#e8eaf0', whiteSpace:'nowrap' }}>{user.nome}<span className="ap-header-cognome"> {user.cognome}</span></div>
              {role === 'cliente' && <div style={{ fontSize:10, color:'#00d68f' }}>Piano attivo</div>}
            </div>
          )}
          <button onClick={logout} style={{ flexShrink:0, background:'rgba(255,77,109,.08)', border:'1px solid rgba(255,77,109,.2)', borderRadius:8, padding:'5px 12px', fontSize:11, color:'#ff4d6d', cursor:'pointer', whiteSpace:'nowrap' }}>
            Esci
          </button>
        </div>
      </div>
      <div style={{ display:'flex', flex:1, overflow:'hidden' }} className="fade-in">
        {View ? <View /> : <div style={{ flex:1, display:'flex', alignItems:'center', justifyContent:'center', color:'#4a5568' }}>Caricamento...</div>}
      </div>
      <Notifica />
    </div>
  );
}

// Config branding per ogni portale
const PORTALE_CONFIG = {
  operatore: {
    titolo: 'Accesso Operatori',
    sottotitolo: 'Portale riservato agli operatori di campo',
    colore: '#4a9eff',
    icon: '◈',
  },
  admin: {
    titolo: 'Pannello Agenzia',
    sottotitolo: 'Area riservata agli amministratori di agenzia',
    colore: '#7ab4e8',
    icon: '⬡',
  },
  hotel: {
    titolo: 'Portale Hotel & Strutture',
    sottotitolo: 'Area riservata alle strutture affiliate AKKKANTO.it',
    colore: '#a855f7',
    icon: '⌂',
  },
  negozio: {
    titolo: 'Portale Attività Affiliate',
    sottotitolo: 'Area riservata alle attività commerciali affiliate',
    colore: '#f97316',
    icon: '◉',
  },
};

function PortaleLogin({ portale, onBack }) {
  const { login, showNotif } = useApp();
  const [form, setForm] = useState({ email:'', password:'' });
  const [loading, setLoading] = useState(false);
  const [showRegistra, setShowRegistra] = useState(false);
  const [registratoOk, setRegistratoOk] = useState(false);
  const cfg = PORTALE_CONFIG[portale] || {};

  // Portale /alfa — superadmin: pagina completamente neutrale
  if (portale === 'superadmin') {
    const inp = { background:'#111620', border:'1px solid rgba(255,255,255,.1)', borderRadius:8, padding:'9px 12px', fontSize:13, color:'#e8eaf0', width:'100%' };
    const handle = async (e) => {
      e.preventDefault();
      setLoading(true);
      try { await login(form.email, form.password); }
      catch(err) { showNotif('Accesso negato', 'error'); }
      finally { setLoading(false); }
    };
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%' }}>
        <div style={{ background:'#0c1018', border:'1px solid rgba(255,255,255,.07)', borderRadius:14, padding:'28px 32px', width:340 }}>
          <form onSubmit={handle} style={{ display:'flex', flexDirection:'column', gap:10 }}>
            <input type="text" placeholder="Email" value={form.email} onChange={e => setForm(f=>({...f,email:e.target.value}))} style={inp} required autoComplete="username" />
            <input type="password" placeholder="Password" value={form.password} onChange={e => setForm(f=>({...f,password:e.target.value}))} style={inp} autoComplete="current-password" />
            <button type="submit" disabled={loading} style={{ background:loading?'#1a2030':'#1e2840', color:'#8892a4', border:'1px solid rgba(255,255,255,.1)', borderRadius:8, padding:'10px', fontWeight:600, fontSize:13, cursor:'pointer', marginTop:4 }}>
              {loading ? '...' : 'Accedi'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  const inp = { background:'#111620', border:'1px solid rgba(255,255,255,.1)', borderRadius:8, padding:'9px 12px', fontSize:13, color:'#e8eaf0', width:'100%' };
  const handle = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(form.email, form.password); showNotif('Accesso effettuato'); }
    catch(err) { showNotif(err.message, 'error'); }
    finally { setLoading(false); }
  };

  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', flexDirection:'column', gap:24 }}>
      {showRegistra && (
        <RegistraOperatoreModal
          onClose={() => setShowRegistra(false)}
          onSuccess={() => { setShowRegistra(false); setRegistratoOk(true); }}
        />
      )}
      <div style={{ textAlign:'center' }}>
        {portale === 'operatore' ? (
          <>
            <div style={{ fontSize:26, fontWeight:900, letterSpacing:-1, color:'#f59e0b' }}>AKKKANTO.IT</div>
            <div style={{ fontSize:12, fontWeight:700, color:'rgba(245,158,11,.7)', letterSpacing:2, marginTop:3 }}>OPERATOR ACCESS POINT</div>
          </>
        ) : (
          <>
            <div style={{ fontSize:32, fontWeight:700, letterSpacing:-1 }}>Alfa<span style={{ color:'#00d68f' }}>Protect</span></div>
            <div style={{ fontSize:11, color:'#4a5568', marginTop:4 }}>Alfa Security Srl — P.IVA 02382450225</div>
          </>
        )}
      </div>
      {registratoOk && (
        <div style={{ background:'rgba(245,158,11,.12)', border:'1px solid rgba(245,158,11,.3)', borderRadius:12, padding:'12px 18px', maxWidth:360, textAlign:'center' }}>
          <div style={{ fontWeight:700, color:'#f59e0b', fontSize:14 }}>✓ Richiesta inviata!</div>
          <div style={{ fontSize:12, color:'#8892a4', marginTop:4 }}>L'agenzia riceverà la tua richiesta e ti approverà a breve.</div>
        </div>
      )}
      <div style={{ background:'#0c1018', border:`1px solid rgba(255,255,255,.07)`, borderRadius:14, padding:'28px 32px', width:360 }}>
        <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:20 }}>
          <span style={{ fontSize:22, color:cfg.colore }}>{cfg.icon}</span>
          <div>
            <div style={{ fontSize:15, fontWeight:600, color:cfg.colore }}>{cfg.titolo}</div>
            <div style={{ fontSize:11, color:'#4a5568', marginTop:2 }}>{cfg.sottotitolo}</div>
          </div>
        </div>
        <form onSubmit={handle} style={{ display:'flex', flexDirection:'column', gap:10 }}>
          <input type="text" placeholder="Email" value={form.email} onChange={e => setForm(f=>({...f,email:e.target.value}))} style={inp} required autoComplete="username" />
          <input type="password" placeholder="Password" value={form.password} onChange={e => setForm(f=>({...f,password:e.target.value}))} style={inp} autoComplete="current-password" />
          <button type="submit" disabled={loading} style={{ background:loading?'#0d1a2a':`rgba(${cfg.colore==='#4a9eff'?'74,158,255':cfg.colore==='#7ab4e8'?'122,180,232':cfg.colore==='#a855f7'?'168,85,247':'249,115,22'},.15)`, color:cfg.colore, border:`1px solid ${cfg.colore}40`, borderRadius:8, padding:'10px', fontWeight:600, fontSize:13, cursor:'pointer', marginTop:4 }}>
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
        {portale === 'operatore' && (
          <button onClick={() => setShowRegistra(true)} style={{ width:'100%', marginTop:12, padding:'11px', borderRadius:8, background:'linear-gradient(135deg,#f59e0b,#d97706)', border:'none', color:'#000', fontWeight:800, fontSize:13, cursor:'pointer' }}>
            Registrati come Operatore
          </button>
        )}
      </div>
      <div style={{ fontSize:11, color:'#4a5568', textAlign:'center' }}>
        Servizio di accompagnamento personale — art. 2222 c.c.
      </div>
    </div>
  );
}

function AppRoot() {
  const { user, setUser, loading, tryAutoLogin } = useApp();
  const [splash, setSplash] = useState(true);
  const [showPWA, setShowPWA] = useState(false);
  const [screen, setScreen] = useState(PORTALE === 'cliente' ? 'landing' : 'login'); // landing | login | register | agency | demo | richiesta | piani | situazioni
  const [showDashboard, setShowDashboard] = useState(false);
  const [showTermini, setShowTermini] = useState(false);

  function apreDashboardOTermini(u) {
    if (u && u.ruolo === 'cliente' && !u.termini_accettati) {
      setShowTermini(true);
    } else {
      setShowDashboard(true);
    }
  }

  // Auto-redirect: se cliente già loggato, vai diretto in dashboard (o termini)
  useEffect(() => {
    if (!loading && user && user.ruolo === 'cliente' && PORTALE === 'cliente') {
      apreDashboardOTermini(user);
    }
  }, [loading, user]);

  // Apri dashboard: solo per clienti
  const openDashboard = async () => {
    if (user) {
      if (user.ruolo !== 'cliente') return;
      apreDashboardOTermini(user);
      return;
    }
    const u = await tryAutoLogin();
    if (u && u.ruolo === 'cliente') { apreDashboardOTermini(u); }
    else if (u) { /* non cliente: ignora */ }
    else { setScreen('login'); }
  };

  const handleAutoLogin = async () => {
    const u = await tryAutoLogin();
    if (!u) setScreen('login');
    else apreDashboardOTermini(u);
  };

  if (splash) return <SplashScreen portale={PORTALE} onDone={() => { setSplash(false); setShowPWA(true); }} />;

  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100%', color:'#00d68f', fontSize:14 }}>
      AKKKANTO.it...
    </div>
  );

  // Clienti: mostra AppLayout solo se hanno esplicitamente richiesto la dashboard
  // Altri ruoli: auto-redirect a AppLayout appena loggati
  if (user && showTermini) return (
    <Suspense fallback={null}>
      <TerminiPage onAccettato={() => {
        setShowTermini(false);
        setShowDashboard(true);
        setUser(prev => prev ? { ...prev, termini_accettati: true } : prev);
      }} />
    </Suspense>
  );

  if (user && (PORTALE !== 'cliente' || showDashboard)) return <AppLayout />;

  // Portali referral: pagine standalone senza auth normale
  if (PORTALE === 'referral_register') {
    return <Suspense fallback={null}><ReferralRegisterPage /></Suspense>;
  }
  if (PORTALE === 'referral_dashboard') {
    return <Suspense fallback={null}><ReferralView /></Suspense>;
  }

  // Portale Business (autenticato via SMS OTP)
  if (PORTALE === 'business_portal') {
    return <Suspense fallback={null}><BusinessPortalPage /></Suspense>;
  }

  // Landing page pubblica Business
  if (PORTALE === 'business_landing') {
    return <Suspense fallback={null}><BusinessLandingPage /></Suspense>;
  }

  // Portali non-cliente: mostra direttamente la pagina di login portale
  if (PORTALE !== 'cliente') {
    return (
      <Suspense fallback={<div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%',color:'#00d68f',fontSize:14}}>Caricamento...</div>}>
        <PortaleLogin portale={PORTALE} />
        <Notifica />
      </Suspense>
    );
  }

  return (
    <>
      {showPWA && <PWAPrompt onDismiss={() => setShowPWA(false)} />}
    <Suspense fallback={<div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100%',color:'#00d68f',fontSize:14}}>Caricamento...</div>}>
      {screen === 'login'       && <OtpLoginForm onRegister={() => setScreen('register')} onBack={() => setScreen('landing')} onSuccess={(u) => apreDashboardOTermini(u)} />}
      {screen === 'register'    && <RegisterPage telefono={sessionStorage.getItem('ap_prefill_phone')} onBack={() => setScreen('landing')} />}
      {screen === 'client-info' && <div style={{height:'100%',overflowY:'auto'}}><ClientInfoPage onRegister={() => setScreen('register')} onBack={() => setScreen('landing')} /></div>}
      {screen === 'agency'      && <AgencyRegisterPage onBack={() => setScreen('landing')} />}
      {screen === 'demo'        && <DemoPage onRegister={() => setScreen('client-info')} onBack={() => setScreen('landing')} />}
      {screen === 'richiesta'    && <RichiestaSpontanea onBack={() => setScreen('landing')} onLogin={() => setScreen('login')} />}
      {screen === 'prenotazione' && <PrenotazioneInfoPage onBack={() => setScreen('landing')} onLogin={() => setScreen('login')} />}
      {screen === 'piani'        && <div style={{height:'100%',overflowY:'auto'}}><PianiPage onBack={() => setScreen('landing')} onRegister={() => setScreen('client-info')} /></div>}
      {screen === 'situazioni'   && <div style={{height:'100%',overflowY:'auto'}}><SituazioniPage onBack={() => setScreen('landing')} onLogin={() => setScreen('login')} onRegister={() => setScreen('client-info')} /></div>}
      {screen === 'landing'      && (
        <LandingPage
          onLogin={()           => setScreen('login')}
          onRegister={()        => setScreen('client-info')}
          onAgency={()          => setScreen('agency')}
          onDemo={()            => setScreen('demo')}
          onRichiesta={()       => setScreen('richiesta')}
          onPrenotazione={()    => setScreen('prenotazione')}
          onAutoLogin={handleAutoLogin}
          onOpenDashboard={openDashboard}
          onPiani={()           => setScreen('piani')}
          onSituazioni={()      => setScreen('situazioni')}
        />
      )}
    </Suspense>
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <style>{STYLE}</style>
      <AppRoot />
    </AppProvider>
  );
}
